// src/components/views/WaitingView.js (New File)
import React from 'react';
import { Loader, X } from 'lucide-react';

export const WaitingView = ({ matchData, onCancelChallenge }) => {
    if (!matchData) {
        return <div className="p-4 text-center">Loading...</div>;
    }

    const opponentName = matchData.player2; // Assuming player1 is always the creator on this screen

    return (
        <div className="min-h-screen flex items-center justify-center p-4">
            <div className="w-full max-w-sm text-center">
                <div className="mx-auto mb-6">
                    <Loader className="w-16 h-16 text-purple-400 animate-spin" />
                </div>
                <h1 className="text-3xl font-bold text-white mb-2">Challenge Sent!</h1>
                <p className="text-slate-400 mb-8">
                    Waiting for <span className="font-bold text-white">{opponentName}</span> to accept the {matchData.gameType} match.
                </p>
                <div className="bg-slate-800/50 rounded-xl p-4 space-y-2 border border-slate-700">
                     <div className="flex justify-between text-sm">
                        <span className="text-slate-400">Race To:</span>
                        <span className="font-semibold">{matchData.player1RaceTo} - {matchData.player2RaceTo}</span>
                    </div>
                     <div className="flex justify-between text-sm">
                        <span className="text-slate-400">Control Mode:</span>
                        <span className="font-semibold capitalize">{matchData.controlMode}</span>
                    </div>
                </div>
                 <button 
                    onClick={onCancelChallenge} 
                    className="w-full mt-6 bg-red-600 text-white py-3 rounded-lg font-semibold hover:bg-red-700 transition-all flex items-center justify-center gap-2"
                >
                    <X size={20} /> Cancel Challenge
                </button>
            </div>
        </div>
    );
};